<template>
  <div class="index">
    <!-- <Header ref="header" title="忘记用户名" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
        <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex: 0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">选择用户类型</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">3</p>
            <p class="stepline3"></p>
            <p class="itemp2">查看用户名</p>
          </div>
          <!-- <div class="stepitem" style="flex: 0.5">
            <p class="itemp1">4</p>

            <p class="itemp2">完成</p>
          </div> -->
        </div>
        <div class="v_showdiv"></div>
         <div class="box_center">
          <p class="center_title">选择用户类型</p>
          <div class="box_nav">
              <van-notice-bar
                wrapable
                :scrollable="false"
                style="background: #deebf7"
                :text="'如果您是法人以及其他组织用户，且已有电子口岸卡，可插卡并选择卡介质方式登录系统，在右上角可查看当前账号用户名。'"
              >
                <template slot="left-icon">
                  <img
                    style="width: 12px; margin-right: 4px;margin-left: 4px;position: relative;top: 1px;"
                    src="@/views/image/userregister/icon_er.png"
                    alt
                    class="notice-bar-image"
                  />
                </template>
              </van-notice-bar>
            </div>
          <div class="center_tip" :class="{'card_active':currentType == 1}" @click="funClick(1)">
              <img
              
                src="@/views/image/userregister/icon_or.png"
                alt
                class="center-image"
              />
              <p class="conter_p1">法人及其他组织用户</p>
              <p class="conter_p2">从事国际贸易进出口环节</p>
              <p class="conter_p3">各类业务的企业法人或其他组织</p>
          </div>
          <div class="center_tip" :class="{'card_active':currentType == 2}" @click="funClick(2)">
              <img
                src="@/views/image/userregister/icon_user.png"
                alt
                class="center-image"
              />
              <p class="conter_p1">自然人用户</p>
              <p class="conter_p2">从事国际贸易进出口环节</p>
              <p class="conter_p3">各类业务的自然人用户</p>
          </div>
        </div>
        <div style="margin: 16px">
            <van-button
                   type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
              @click="next()"
              >下一步</van-button
            >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
  Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";
export default {
  name: "restname",
  data() {
    return {
      statusBar: 0,
      currentType:Number,
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  },

  methods: {
    funClick(val){
        this.currentType = val
    },
      next(){
        if (this.currentType==1) {
          this.$router.push({
            path: "/restNamelegalperson",
            query: {
             
            },
          });
        }else if(this.currentType==2) {
          this.$router.push({
            path: "/restNameVerify",
            query: {
             
            },
          });
        }else{
          this.$toast('请选择用户类型')
        }
      }
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }
.index{
  display: flex;
  flex-direction: column;
  height: 100%;
   box-sizing: border-box;
}
.windowmain {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  .boxmain {
    width: 100%;
      .box_nav {
    width: 100%;
    margin: 10px auto;
  }
  .van-notice-bar {
    color: #1f4e79;
    font-size: 12px;
    padding: 0px 10px;
    font-weight: 400;
    border-top: 1px solid #c5dcf1;
    border-bottom: 1px solid #c5dcf1;
    align-items: baseline;
  }
      .box_center{
          padding: 15px 15px 0px 15px;
          height: auto;
        .center_title{
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
        .center_tip{
          width: 100%;
          text-align: center;
          background: #fff;
          border-radius: 4px;
          margin: 20px auto;
          padding-bottom: 15px;
          border: 1px solid #f5f7f8;
          box-shadow: 0px 1px 2px 2px rgba(206,206,206,0.25);
        }
        .card_active{
          border-color: #00599c;
          background: #f5f7f8;
        }
        .center-image{
          margin: 12px auto;
          width: 50px;
        }
        .conter_p1{
          font-size: 15px;
          color: #333;
            line-height: 20px;
            margin-bottom: 6px;
          cursor: pointer;
        }
        .conter_p2,.conter_p3{
          font-size: 12px;
            line-height: 18px;
          color: #999;
          cursor: pointer;
        }
        }
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .boxstep {
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
      padding: 14px 11px 16px 11px;
      .stepitem {
        flex: 1;
        position: relative;
        text-align: center;
        .stepline {
          position: absolute;
          width: 84px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
          top: 9px;
        }
        .stepline2 {
          position: absolute;
          width: 94px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
          top: 9px;
        }
        .itemp1 {
          width: 17px;
          height: 17px;
          background: #d5d5d5;
          font-size: 11px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          line-height: 18px;
          display: block;
          position: relative;
          margin: 0 auto;
        }
        .itemp2 {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
      .stepitemactive {
        .itemp1 {
          background: #00599c;
        }
        .itemp2 {
          color: #00599c;
        }
      }
    }
  }
  .v_showdiv {
    height: 12px;
    background: #f7f8fa;
  }
  .boxinput {
    // margin-top: 12px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;

    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }
  ::v-deep .van-cell::after {
    border-bottom: 0px solid #ddd;
  }
  .vertical1 .van-cell {
    width: 68%;
  }
  .verificationCode {
    top: 7px;
  }
  .verificationCode .codeImg {
    width: 91px;
    height: 32px;
  }

  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
}
</style>